import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import moment from 'moment';

import { formatDateForSprintCallsAndSMSAPI } from 'helpers/formatters';
import { YEAR_DATE_FORMAT } from '../constants';
import FormError from './FormError';
import InputField from './InputField';

let SprintCallRecordsForm = ({
  handleSubmit,
  errorMsg,
  saveStatus,
  initialValues,
  onSubmitVoice,
  subId,
  success,
}) => (
  <div>
    <form>
      <Field component={InputField} name="email" label="Email*" />
      <br />
      <label>Start Date*</label>
      <Field
        component="input"
        type="date"
        name="start_date"
        max={moment().format('YYYY-MM-DD')}
        value={initialValues.start_date}
      />
      <br />
      <br />
      <label>End Date*</label>
      <Field
        component="input"
        type="date"
        name="end_date"
        max={moment().format('YYYY-MM-DD')}
        value={initialValues.end_date}
      />
      <br />
      <br />
      <button
        className="btn btn-default"
        disabled={saveStatus === 'PENDING'}
        onClick={handleSubmit((values) =>
          onSubmitVoice({
            ...values,
            start_date: formatDateForSprintCallsAndSMSAPI(values.start_date),
            end_date: formatDateForSprintCallsAndSMSAPI(values.end_date),
            subscription: subId,
          }),
        )}
      >
        Send Email
      </button>
      {success && <span className="text-success">&#8195;Success.</span>}
    </form>
    <br />
    {errorMsg && <FormError error={errorMsg} />}
  </div>
);

const validate = (values) => {
  let errors = {};

  if (!values.start_date) {
    errors.start_date = 'Required';
  }
  if (!values.end_date) {
    errors.end_date = 'Required';
  }
  if (!values.email) {
    errors.email = 'Required';
  }

  return errors;
};

const mapStateToProps = () => ({
  initialValues: {
    start_date: moment().subtract(3, 'months').format(YEAR_DATE_FORMAT),
    end_date: moment().format(YEAR_DATE_FORMAT),
  },
});

SprintCallRecordsForm = connect(mapStateToProps)(
  reduxForm({
    form: 'sprintCallRecord',
    validate,
  })(SprintCallRecordsForm),
);

export default SprintCallRecordsForm;
